import lodash from 'lodash';
import { Store } from '@/store/mainStore';
type PrescriptionPropCategories = 'shellModifications' | 'postingOptions' | 'accommodations' | 'topCovers';

interface PropertySelector {
	category: PrescriptionPropCategories;
	property: string;
}

type MutexPropsBySideGroup = PropertySelector[];

const MUTEX_PROPS_BY_SIDE: MutexPropsBySideGroup[] = [
	[
		{ category: 'shellModifications', property: 'cutoutAndStyloid' },
		{ category: 'shellModifications', property: 'wellAndStyloid' }
	],
	[
		{ category: 'shellModifications', property: 'cutoutAndFirst' },
		{ category: 'shellModifications', property: 'firstRayCutout' }
	],
	[
		{ category: 'accommodations', property: 'heelCushion' },
		{ category: 'accommodations', property: 'heelSpurPad' }
	],
	[
		{ category: 'accommodations', property: 'metBar' },
		{ category: 'accommodations', property: 'metPads' }
	]
];

// HACK: Some properties are defining only the Side while others have side as a field
const MUTEX_PROPS_BY_SIDE_NO_SIDE_FIELD = ['cutoutAndStyloid', 'wellAndStyloid', 'cutoutAndFirst'];

function fetchRelatedPropsBySide(property: string) {
	const relatedGroup = MUTEX_PROPS_BY_SIDE.filter((group) => group.some((selector) => selector.property === property));
	if (relatedGroup.length === 0) {
		throw new Error(`Invalid property ${property} provided`);
	}
	const [currentProp, relatedProps] = lodash.partition(relatedGroup[0], ['property', property]);
	return {
		current: currentProp[0],
		related: relatedProps
	};
}

export function getDisabledValuesBySideForProp(state: Store, property: string) {
	const { current, related } = fetchRelatedPropsBySide(property);
	const disabledOptionsList: Set<any> = new Set();
	related.forEach((other: PropertySelector) => {
		let value = state.prescription.newPrescription[other.category][other.property];
		if (!MUTEX_PROPS_BY_SIDE_NO_SIDE_FIELD.includes(other.property)) {
			value = value.side;
		}
		if (value !== 'none') {
			disabledOptionsList.add('both');
			if (value === 'both') {
				disabledOptionsList.add('left');
				disabledOptionsList.add('right');
			} else {
				disabledOptionsList.add(value);
			}
		}
	});
	return Array.from(disabledOptionsList);
}
